package com.schoolconnect.app.feature.schools.edit

data class EditSchoolFormValues(
    val id: String = "",
    val status: String = "",
    val schoolName: String = "",
    val schoolCode: String = "",
    val board: String = "",
    val type: String = "",
    val medium: String = "",
    val createdOn: String = "",
    val createdBy: String = "",
    val updatedOn: String = "",
    val updatedBy: String = "",
    val addressLine1: String = "",
    val addressLine2: String = "",
    val city: String = "",
    val district: String = "",
    val state: String = "",
    val country: String = "",
    val pinCode: String = "",
    val schoolPhone: String = "",
    val schoolEmail: String = "",
    val primaryContact: String = "",
    val primaryPhone: String = "",
    val primaryEmail: String = "",
    val secondaryContact: String = "",
    val secondaryPhone: String = "",
    val secondaryEmail: String = "",
    val schoolLogoBytes: ByteArray? = null,
    val schoolLogoFileName: String = "",
    val attachmentFileId: String = "",
    val schoolLogoUrl: String = "",
    val schoolDescription: String = ""
)

data class EditSchoolValidationErrors(
    val status: String = "",
    val schoolName: String = "",
    val schoolCode: String = "",
    val board: String = "",
    val type: String = "",
    val medium: String = "",
    val addressLine1: String = "",
    val city: String = "",
    val district: String = "",
    val state: String = "",
    val country: String = "",
    val pinCode: String = "",
    val schoolPhone: String = "",
    val schoolEmail: String = "",
    val primaryContact: String = "",
    val primaryPhone: String = "",
    val primaryEmail: String = "",
    val secondaryPhone: String = "",
    val secondaryEmail: String = "",
    val schoolDescription: String = ""
) {
    val hasAnyError: Boolean
        get() = listOf(
            status,
            schoolName,
            schoolCode,
            board,
            type,
            medium,
            addressLine1,
            city,
            district,
            state,
            country,
            pinCode,
            schoolPhone,
            schoolEmail,
            primaryContact,
            primaryPhone,
            primaryEmail,
            secondaryPhone,
            secondaryEmail
        ).any { it.isNotBlank() }
}

data class EditSchoolUiState(
    val original: EditSchoolFormValues = defaultEditSchoolFormValues(),
    val form: EditSchoolFormValues = defaultEditSchoolFormValues(),
    val validationErrors: EditSchoolValidationErrors = EditSchoolValidationErrors(),
    val hasSubmitted: Boolean = false,
    val isSaving: Boolean = false,
    val isUploadingLogo: Boolean = false,
    val isLoading: Boolean = false,
    val isCreatedByLoading: Boolean = false,
    val isUpdatedByLoading: Boolean = false,
    val errorMessage: String = ""
) {
    val isDirty: Boolean get() = original != form
    val canSave: Boolean get() = isDirty && !isSaving && !isLoading && !isUploadingLogo
    val showErrors: Boolean get() = hasSubmitted
}

sealed interface EditSchoolUiEvent {
    data object RetryLoad : EditSchoolUiEvent
    data class FieldChanged(val field: EditSchoolField, val value: String) : EditSchoolUiEvent
    data class LogoSelected(val fileName: String, val bytes: ByteArray) : EditSchoolUiEvent
    data object SaveClicked : EditSchoolUiEvent
    data object ResetClicked : EditSchoolUiEvent
}

enum class EditSchoolField {
    STATUS,
    SCHOOL_NAME,
    SCHOOL_CODE,
    BOARD,
    TYPE,
    MEDIUM,
    CREATED_ON,
    CREATED_BY,
    UPDATED_ON,
    UPDATED_BY,
    ADDRESS_LINE1,
    ADDRESS_LINE2,
    CITY,
    DISTRICT,
    STATE,
    COUNTRY,
    PIN_CODE,
    SCHOOL_PHONE,
    SCHOOL_EMAIL,
    PRIMARY_CONTACT,
    PRIMARY_PHONE,
    PRIMARY_EMAIL,
    SECONDARY_CONTACT,
    SECONDARY_PHONE,
    SECONDARY_EMAIL,
    SCHOOL_DESCRIPTION
}
